module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "examination-result"
  }, [_c('div', {
    staticClass: "examination-result__text"
  }, [_vm._v("Оценка за лучший результат: " + _vm._s(_vm.result.results.evaluation))]), _c('div', {
    staticClass: "examination-result__text"
  }, [_vm._v("Количество набранных баллов: " + _vm._s(_vm.result.results.points_received))]), _c('div', {
    staticClass: "examination-result__text"
  }, [_vm._v("Количество сделанных попыток: " + _vm._s(_vm.result.result_params.last_attempt))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7359f682","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/compopnents/block/components/ExaminationResult/ExaminationResult.vue
// module id = c5906d6c5b130546f75c
// module chunks = 89